const TiposStatusCliente = {
   AguardandoAprovacao: 1,
   Reprovado: 2,
   Ativo: 3,
   Inativo: 4,
   Bloqueado: 5,
   PreCadastro: 6,
}

export default TiposStatusCliente;